import {AddressItemType, IAddressItem} from '../../shared/types/addressItem.types';
import {AddressItemService} from '../services/addressItem.service';
import {ISelectOption} from './option.type';

export interface IAddressItemSelectOption extends Pick<ISelectOption, 'label'> {
  value: IAddressItem;
}

export const searchAddressItemStrategy = async (str: string, type: AddressItemType) => {
  const {
    data: {content},
  } = await AddressItemService.getAll({
    params: {
      itemType: type,
      name: str.trim(),
    },
  });

  if (content.length) {
    return content.map((i) => {
      let newName = i.name;

      if (i.prefix) {
        if (type === 'REGION') {
          newName = !i.prefix.toLowerCase().includes('республика')
            ? `${i.name} ${i.prefix}`
            : `${i.prefix.charAt(0).toUpperCase() + i.prefix.slice(1)} ${i.name}`;
        } else {
          newName = !i.name.toLowerCase().includes(i.prefix.toLowerCase()) ? `${i.prefix} ${i.name}` : i.name;
        }
      }

      return {value: i, label: newName};
    }) as IAddressItemSelectOption[];
  }

  return [];
};
